// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3icz_","col":"styles_col__Y37KP"};